import axios from "axios";
import Constants from "./constant";
import moment from "moment";
import CryptoJS from "crypto-js";
// import { Capacitor } from "@capacitor/core";
// import { SSLCertificateChecker } from "@aalzehla/capacitor-ssl-pinning";

export const axiosClient = axios.create({
    baseURL: `${Constants.env.lambdaApiServer}`,
});

// // SSL Pinning configuration - SHA-256 fingerprints for each domain
// // Format: Colon-separated hex (as returned by the plugin)
// // The plugin normalizes fingerprints, but it's safer to use the format it returns
// const SSL_PINS = {
//     "40bxy7a7v3.execute-api.ap-southeast-1.amazonaws.com": "BE:7F:8A:67:BF:34:48:41:6E:5C:06:9F:9C:75:A5:BD:74:75:4E:26:E8:0E:ED:E0:00:AA:2E:A3:BB:F9:4A:40",
//     "qvas3cc2q0.execute-api.ap-southeast-1.amazonaws.com": "CE:67:87:15:A6:9D:F2:6B:C5:CA:D3:6D:DA:FF:8B:7D:AA:70:24:60:BD:A9:0E:1F:56:74:5F:EB:07:72:2B:5B",
//     "y6idvn45ge.execute-api.us-east-1.amazonaws.com": "47DEQpj8HBSa+/TImW+5JCeuQeRkm5NMpJWZG3hSuFU=",
//     "parentapp.s3.ap-southeast-1.amazonaws.com": "RNc9o5Ty/ZI17AM/gdJg9qM8h2E65oFtMfcT1Fw314U=",
//     "fp-portal-uploads.s3.ap-southeast-1.amazonaws.com": "RNc9o5Ty/ZI17AM/gdJg9qM8h2E65oFtMfcT1Fw314U=",
// };
//
// // SSL Pinning interceptor for native platforms
// if (Capacitor.isNativePlatform()) {
//     axiosClient.interceptors.request.use(
//         async (config) => {
//             // Build full URL
//             const url = config.url || "";
//             const baseURL = config.baseURL || "";
//             const fullUrl = url.startsWith("http")
//                 ? url
//                 : `${baseURL}${url.startsWith("/") ? url : `/${url}`}`;
//
//             // Extract hostname
//             let hostname = null;
//             try {
//                 const urlObj = new URL(fullUrl);
//                 hostname = urlObj.hostname;
//             } catch (e) {
//                 // If URL parsing fails, try regex
//                 const match = fullUrl.match(/https?:\/\/([^/]+)/);
//                 hostname = match ? match[1] : null;
//             }
//
//             // Check if we have a pin for this hostname
//             if (hostname && SSL_PINS[hostname]) {
//                 const fingerprint = SSL_PINS[hostname];
//
//                 try {
//                     // Ensure URL is HTTPS
//                     const httpsUrl = fullUrl.startsWith("http://")
//                         ? fullUrl.replace("http://", "https://")
//                         : fullUrl;
//
//                     console.log(`[SSL Pinning] Checking ${hostname}`);
//
//                     // Call the plugin's checkCertificate method
//                     const result = await SSLCertificateChecker.checkCertificate({
//                         url: httpsUrl,
//                         fingerprint: fingerprint,
//                     });
//
//                     // Reject if fingerprint doesn't match
//                     if (!result.fingerprintMatched) {
//                         const errorMsg = `SSL Certificate pinning failed for ${hostname}`;
//                         console.error(`[SSL Pinning] ${errorMsg}`);
//                         return Promise.reject(new Error(errorMsg));
//                     }
//
//                     console.log(`[SSL Pinning] ✅ Certificate verified for ${hostname}`);
//                 } catch (error) {
//                     console.error(`[SSL Pinning] Error checking certificate:`, error);
//                     return Promise.reject(
//                         new Error(`SSL Certificate verification failed: ${error.message}`)
//                     );
//                 }
//             }
//
//             return config;
//         },
//         (error) => {
//             return Promise.reject(error);
//         }
//     );
// }
// Request blocking mechanism for childreload
let isReloadInProgress = false;
let pendingRequests = [];
const RELOAD_ENDPOINT = "/parentapp/childLoginReloadDetails";

// Function to start blocking requests (called when reload starts)
export const startRequestBlocking = () => {
    console.log("[RequestBlocking] Starting request blocking for childreload");
    isReloadInProgress = true;
};

// Function to stop blocking requests (called when reload completes)
export const stopRequestBlocking = () => {
    console.log("[RequestBlocking] Stopping request blocking, processing pending requests");
    isReloadInProgress = false;

    // Process all pending requests
    const requestsToProcess = [...pendingRequests];
    pendingRequests = [];

    requestsToProcess.forEach(({ resolve, config }) => {
        console.log("[RequestBlocking] Processing pending request:", config.url);
        resolve(config);
    });
};

// Request interceptor to block requests during reload
axiosClient.interceptors.request.use(
    (config) => {
        // Allow the reload request itself to proceed
        if (config.url?.includes(RELOAD_ENDPOINT)) {
            console.log("[RequestBlocking] Allowing reload request:", config.url);
            return config;
        }

        // Block all other requests if reload is in progress
        if (isReloadInProgress) {
            console.log("[RequestBlocking] Blocking request during reload:", config.url);

            // Return a promise that will be resolved when reload completes
            return new Promise((resolve) => {
                pendingRequests.push({ resolve, config });
            });
        }

        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

let getCurrentDate = () => {
    return moment().utc().format("YYYY-MM-DD");
};
export const getAuthToken = (child_id = undefined, parent = undefined) => {
    const saltKey = "!foot@prints#education#";
    let token = getCurrentDate() + "_" + saltKey;
    console.log("Generating Token ...");

    if (child_id && parent) {
        token =
            child_id + "_" + getCurrentDate() + "_" + parent + "_" + saltKey;
    }
    // return crypto.createHash("md5").update(token).digest("hex");
    return CryptoJS.MD5(token).toString(CryptoJS.enc.Hex);
};

